import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import type { BreadcrumbItem } from '../../seo-breadcrumbs';

interface BreadcrumbTrailCrumb extends BreadcrumbItem {
  readonly isCurrent: boolean;
}

/**
 * Visible `<nav aria-label="Breadcrumb"><ol>` trail. Takes the same
 * `BreadcrumbItem[]` shape `createBreadcrumbList()` (../../seo-breadcrumbs.ts)
 * turns into JSON-LD, so a route's on-page trail and its structured-data
 * markup are built from one list and cannot disagree. Does not touch JSON-LD
 * emission itself — routes still call `createBreadcrumbList()` separately for
 * `data.seo.jsonLd`.
 */
@Component({
  selector: 'app-breadcrumb-trail',
  imports: [RouterLink],
  templateUrl: './breadcrumb-trail.component.html',
  styleUrl: './breadcrumb-trail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbTrailComponent {
  readonly items = input.required<readonly BreadcrumbItem[]>();

  protected readonly trail = computed<readonly BreadcrumbTrailCrumb[]>(() => {
    const items = this.items();
    return items.map((item, index) => ({
      ...item,
      isCurrent: index === items.length - 1,
    }));
  });
}
